import { useState, useEffect } from 'react';

function serializeValue(value) {
  try {
    return JSON.stringify(value);
  } catch (error) {
    console.log("error serializing ", value);
  }

  return;
}
function deserializeValue(value) {
  try {
    value = JSON.parse(value);
    return value;
  } catch (error) {
    console.log("error deserializing ", value);
  }

  return;
}

function useLocalStorage(key, initialValue) {
  var _useState = useState(function () {
    var value = deserializeValue(window.localStorage.getItem(key));

    if (value === null || value === undefined) {
      return initialValue;
    }

    return value;
  }),
      item = _useState[0],
      setItem = _useState[1];

  useEffect(function () {
    var serializedItem = serializeValue(item);

    if (serializedItem) {
      window.localStorage.setItem(key, serializedItem);
    }
  }, [key, item]);
  return [item, setItem];
}

function useSessionStorage(key, initialValue) {
  var _useState = useState(function () {
    var value = deserializeValue(window.sessionStorage.getItem(key));

    if (value === null || value === undefined) {
      return initialValue;
    }

    return value;
  }),
      item = _useState[0],
      setItem = _useState[1];

  useEffect(function () {
    var serializedItem = serializeValue(item);

    if (serializedItem) {
      window.sessionStorage.setItem(key, serializedItem);
    }
  }, [key, item]);
  return [item, setItem];
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function useForm(config) {
  var validateOnChange = config.validateOnChange,
      validateOnBlur = config.validateOnBlur,
      initialValues = config.initialValues;

  var _useState = useState(config.initialValues),
      values = _useState[0],
      setValues = _useState[1];

  var _useState2 = useState({}),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState({}),
      touched = _useState3[0],
      setTouched = _useState3[1];

  var _useState4 = useState(false),
      isSubmitting = _useState4[0],
      setIsSubmitting = _useState4[1];

  var handleSubmit = function handleSubmit() {
    try {
      var _temp3 = function _temp3() {
        setIsSubmitting(false);
      };

      setIsSubmitting(true);
      var t = {};

      for (var _i = 0, _Object$keys = Object.keys(values); _i < _Object$keys.length; _i++) {
        var k = _Object$keys[_i];
        t[k] = true;
      }

      setTouched(t);

      var _errors = config.validate(values);

      setErrors(_errors);

      var _temp4 = function () {
        if (Object.keys(_errors).length === 0) {
          return Promise.resolve(config.onSubmit(values)).then(function () {});
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleReset = function handleReset() {
    setTouched({});
    setValues(initialValues);
    setErrors({});
  };

  var handleBlur = function handleBlur(event) {
    var targetName = event.target.name;
    setTouched(function (values) {
      var _extends2;

      return _extends({}, values, (_extends2 = {}, _extends2[targetName] = true, _extends2));
    });

    if (validateOnBlur) {
      setErrors(config.validate(values));
    }
  };

  var handleChange = function handleChange(event) {
    var newValues;

    if (event.target.type === "checkbox") {
      var _extends3;

      newValues = _extends({}, values, (_extends3 = {}, _extends3[event.target.name] = event.target.checked, _extends3));
    } else {
      var _extends4;

      newValues = _extends({}, values, (_extends4 = {}, _extends4[event.target.name] = event.target.value, _extends4));
    }

    setValues(newValues);

    if (validateOnChange) {
      setErrors(config.validate(newValues));
    }
  };

  var setFieldValue = function setFieldValue(field, value, shouldValidate) {
    if (shouldValidate === void 0) {
      shouldValidate = true;
    }

    setValues(function (prevState) {
      var _extends5;

      var newValues = _extends({}, prevState, (_extends5 = {}, _extends5[field] = value, _extends5));

      if (shouldValidate) {
        setErrors(config.validate(newValues));
      }

      return newValues;
    });
  };

  return {
    values: values,
    errors: errors,
    touched: touched,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    handleReset: handleReset,
    handleBlur: handleBlur,
    setFieldValue: setFieldValue,
    isSubmitting: isSubmitting
  };
}

export { useForm, useLocalStorage, useSessionStorage };
//# sourceMappingURL=hcss-hooks.esm.js.map
